import useGlobalPromise from "./useGlobalPromise";
import axios from "axios";
import { BookingCode } from "./Domain";

const useBookingCodes = () =>
	useGlobalPromise("ald_booking_codes", async () =>
		(await axios.get<BookingCode[]>(`/api/booking-codes`)).data
	);

export default useBookingCodes;
